import { type RouterOutputs } from './trpc';

export enum ModerationReportType {
  POST = 'POST',
  USER = 'USER',
  SPACE = 'SPACE',
  FACTIII = 'FACTIII'
}

export type RuleItem = RouterOutputs['reports']['rulesList'][0];
